import {NewDonorRequest} from "../../types";
import {BE_BASE_URL} from "../../utils/config";

export const storeDonoInfo = (info: Partial<NewDonorRequest>): boolean => {
  try {
    sessionStorage.setItem("newDonorInfo", JSON.stringify(info));
    return true;
  } catch (error) {
    console.log('errore nel salvataggio temporaneo delle informazioni donatore', error);
    return false
  }
}

export const findIfAlreadyRegistered = async (request: Partial<NewDonorRequest>): Promise<{isRegistered: boolean, message?: string}> => {
  const token = localStorage.getItem('token');
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  const response = await fetch(BE_BASE_URL + '/raccolta/isAlreadyRegistered', {
    method: "POST",
    headers: headers,
    body: JSON.stringify(request),
  });

  if (response.status === 200) {
    return { isRegistered: false };
  } else if (response.status === 409) {
    const result = await response.json();
    return { isRegistered: true, message: result.message };
  } else {
    const errorBody = await response.text();
    console.error(`HTTP error! status: ${response.status}, body: ${errorBody}`);
    throw new Error(`HTTP error! status: ${response.status}`);
  }
};
